import AbstractChannel from './AbstractChannel'

export default class CheapAirportParking extends AbstractChannel {

  name = 'cheap_airport_parking'
  title = 'Cheap Airport Parking'
  titleShort = 'CAP'
  color = '#AEC7E8'

  supportedFeatures = ['blackouts']

}
